<div class="mx-auto max-w-screen-sm px-5 pb-60 md:max-w-full">
  <h1 class="py-6 font-accent text-2xl font-bold">
    {{ 'pay-at-table.user-checks.title' | translate }}
  </h1>
  @if ((checksPageVm$ | async) ?? loadingVm; as vm) {
    @if (!vm.isChecksLoading) {
      <div class="grid-cols-2 gap-6 md:grid lg:grid-cols-3 xl:grid-cols-4">
        @if (vm.checks.length > 0) {
          @for (check of vm.checks; track check.id) {
            <div>
              <app-check-card
                [check]="check"
                (cardClick)="goToCheckDetails(forceType($event).id)"
              ></app-check-card>
            </div>
          }
        } @else {
          <div class="ng-star-inserted py-2 text-center text-sm text-neutral-500">
            {{ 'orders.no-current-orders' | translate }}
          </div>
        }
      </div>
    } @else {
      <div class="mb-8xs">
        @for (i of [].constructor(20); track $index) {
          <app-order-card-skeleton></app-order-card-skeleton>
        }
      </div>
    }
  }
</div>
